import React from "react";
import { FaJava, FaRobot } from "react-icons/fa";
import { HiCircleStack } from "react-icons/hi2";
import {
  SiAndroidstudio,
  SiBootstrap,
  SiFirebase,
  SiFigma,
  SiGit,
  SiJenkins,
  SiJira,
  SiJavascript,
  SiN8N,
  SiNextdotjs,
  SiNodedotjs,
  SiPostman,
  SiPython,
  SiReact,
  SiRedux,
  SiSwift,
  SiTailwindcss,
  SiTypescript,
  SiXcode,
} from "react-icons/si";
import {
  TbBrain,
  TbDatabaseSearch,
  TbTopologyComplex,
  TbVectorBezier2,
} from "react-icons/tb";

const skills = [
  {
    title: "Mobile & front-end",
    values: [
      [SiReact, "React Native", "#61DAFB"],
      [SiReact, "React", "#61DAFB"],
      [SiTypescript, "TypeScript", "#3178C6"],
      [SiJavascript, "JavaScript", "#F7DF1E"],
      [FaJava, "Java", "#E76F00"],
      [SiSwift, "Swift", "#F05138"],
    ],
  },
  {
    title: "Web & UI",
    values: [
      [SiNextdotjs, "Next.js", "#111827"],
      [SiNodedotjs, "Node.js", "#339933"],
      [SiRedux, "Redux", "#764ABC"],
      [SiRedux, "RTK Query", "#764ABC"],
      [SiTailwindcss, "Tailwind CSS", "#06B6D4"],
      [SiBootstrap, "Bootstrap", "#7952B3"],
    ],
  },
  {
    title: "AI engineering",
    values: [
      [SiPython, "Python", "#3776AB"],
      [FaRobot, "AI Agents", "#7C3AED"],
      [TbBrain, "LLMs", "#8B5CF6"],
      [TbDatabaseSearch, "RAG", "#00A67E"],
      [TbVectorBezier2, "Embeddings", "#EC4899"],
      [TbTopologyComplex, "Hybrid Retrieval", "#0891B2"],
      [HiCircleStack, "Qdrant", "#DC244C"],
      [SiN8N, "n8n", "#EA4B71"],
    ],
  },
  {
    title: "Delivery & quality",
    values: [
      [SiAndroidstudio, "Android Studio", "#3DDC84"],
      [SiJenkins, "CI/CD", "#D24939"],
      [SiFigma, "Figma", "#F24E1E"],
      [SiFirebase, "Firebase", "#FFCA28"],
      [SiGit, "Git", "#F05032"],
      [SiJira, "Jira", "#0052CC"],
      [SiPostman, "Postman", "#FF6C37"],
      [SiXcode, "Xcode", "#147EFB"],
    ],
  },
];

const Skill = () => (
  <section id="skills" className="section">
    <p className="eyebrow">Capabilities</p>
    <h2 className="section-title">A focused technical toolkit.</h2>
    <div className="skills-grid">
      {skills.map((group, groupIndex) => (
        <div className="panel skill-group" key={group.title}>
          <div className="skill-group-head">
            <span className="skill-group-index">0{groupIndex + 1}</span>
            <h3>{group.title}</h3>
            <span className="skill-group-count">
              {group.values.length} tools
            </span>
          </div>
          <div className="skill-tags">
            {group.values.map(([Icon, name, color]) => (
              <span
                key={name}
                data-skill={name}
                style={{ "--skill-color": color }}
              >
                <Icon aria-hidden="true" />
                <b>{name}</b>
                <i aria-hidden="true" />
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default Skill;
